// components/ui/MenuModal.tsx
import { LucideIcon } from "lucide-react";
import BaseModal from "./Modal";
import { ReactNode, useState } from "react";

export interface Menu {
  label: string;
  icon: LucideIcon | null; // Peut être null
  onClick?: () => void;
  subMenu?: Menu[];
  className?: string;
}

interface MenuModalProps {
  menu: Menu[];
  isOpen: boolean;
  onClose: () => void;
  title: string;
  icon: ReactNode;
}

export default function MenuModal({ menu, isOpen, onClose, title, icon }: MenuModalProps) {
  const [expandedMenu, setExpandedMenu] = useState<string | null>(null);

  const handleItemClick = (item: Menu) => {
    if (item.subMenu) {
      setExpandedMenu(expandedMenu === item.label ? null : item.label);
      return;
    }
    if (item.onClick) {
      item.onClick();
      onClose();
    }
  };

  const renderMenuItem = (item: Menu, depth: number = 0) => {
    const IconComponent = item.icon;
    const hasSubMenu = item.subMenu && item.subMenu.length > 0;
    const isExpanded = expandedMenu === item.label;

    return (
      <div key={item.label}>
        <button
          onClick={() => handleItemClick(item)}
          className={`w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 transition-colors border-b border-gray-100 last:border-0 ${
            depth > 0 ? "pl-12" : ""
          } ${item.className || ""}`}
        >
          <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center shrink-0">
            {IconComponent ? (
              <IconComponent size={18} className="text-primary" />
            ) : (
              <span className="text-primary text-xs font-bold">•</span>
            )}
          </div>
          <span className="text-sm font-medium text-gray-700 flex-1">{item.label}</span>
          {hasSubMenu && (
            <span className="text-gray-400 text-xs">
              {isExpanded ? "▲" : "▼"}
            </span>
          )}
        </button>
        {hasSubMenu && isExpanded && (
          <div className="border-l-2 border-gray-200 ml-8">
            {item.subMenu!.map((subItem) => renderMenuItem(subItem, depth + 1))}
          </div>
        )}
      </div>
    );
  };

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} title={title}>
      <div className="py-2">
        {menu.map((item) => renderMenuItem(item))}
      </div>
    </BaseModal>
  );
}